import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AlertV2 as Alert, Button, Modal } from '@feathr/components';
import { EAlertType } from '@feathr/components/src/AlertV2/AlertV2';

interface IGeoFilterDefaultModalProps {
  opened: boolean;
  onClose: () => void;
  geoFilterName: string;
}

function GeoFilterDefaultModal({
  opened: isModalOpen,
  onClose: closeModal,
  geoFilterName,
}: Readonly<IGeoFilterDefaultModalProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      description={geoFilterName}
      onClose={closeModal}
      opened={isModalOpen}
      rightActions={[
        <Button key={'cancel'} onClick={closeModal}>
          {t('Cancel')}
        </Button>,
        <Button key={'confirm'} onClick={closeModal} type={'primary'}>
          {t('Confirm')}
        </Button>,
      ]}
      title={t('Assign as default')}
    >
      <Alert title={t('Heads up!')} type={EAlertType.info}>
        {t(
          'Setting this geofilter set as the default only affects new campaigns. Existing campaigns will remain unchanged.',
        )}
      </Alert>
    </Modal>
  );
}

export default GeoFilterDefaultModal;
